/** @jsx jsx */
import { CreatedOn } from "../CreatedOn"
import { Duration } from "../Duration"
import { Emoji } from "../Emoji"
import { Highlighter } from "../Highlighter"
import { Incident } from "../../types"
import { IncidentBadge } from "../IncidentBadge"
import { jsx, Heading, Box } from "theme-ui"
import { Participants } from "../Participants"
import { Severity } from "../Severity"
import { SlackButton } from "../SlackButton"
import * as styles from "./styles"
import React from "react"

interface IncidentProps {
  className?: string
  incident: Incident
  searchWords: string[]
}

export const IncidentRow: React.FC<IncidentProps> = ({
  className,
  incident,
  searchWords,
}) => {
  const {
    name,
    severity,
    participants,
    channelId,
    workspace,
    createdOn,
    duration,
    incidentStatusId,
  } = incident

  const emoji = severity?.emoji

  return (
    <Box as="tr" className={className} sx={styles.root}>
      <td>{emoji && <Emoji sx={{ fontSize: 4 }} text={emoji} />}</td>
      <td>
        <IncidentBadge
          incidentStatusId={incidentStatusId}
          sx={styles.incidentBadge}
        />
      </td>
      <td>
        <Heading variant="h6">
          <Highlighter searchWords={searchWords} textToHighlight={name} />
        </Heading>
      </td>
      <Box as="td" sx={{ position: "relative", top: "-1px" }}></Box>
      <td>
        <Severity
          severity={severity}
          searchWords={searchWords}
          sx={styles.severity}
        />
        <Participants participants={participants} />
      </td>
      <Box as="td" sx={{ textAlign: "right" }}>
        <CreatedOn createdOn={createdOn} />
        <Duration duration={duration} />
      </Box>
      <td>
        <SlackButton
          channelId={channelId}
          sx={styles.slackButton}
          teamId={workspace.teamId}
        />
      </td>
    </Box>
  )
}
